import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }

import AddSubscription from "@/components/1crm/fitur/management-subscription/add-subscription.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import store from "@/store";
import { Actions } from "@/store/enums/StoreEnums";
import { onBeforeMount } from "vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

onBeforeMount(() => {
  store.dispatch(Actions.VERIFY_AUTH_USER);
  setCurrentPageBreadcrumbs("Detail Management Subscription", [
    "Master Fitur","Management Subscription",
  ]);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AddSubscription)
  ]))
}
}

})